<script lang="ts">
	import type { ComponentType } from '$lib/types/props';

	export let component: ComponentType;

	let instance;
	let initialized = false;

	$: if (component?.listeners && instance && !initialized) {
		Object.keys(component.listeners).forEach((key) => {
			instance.$on(key, component.listeners[key]);
		});
		initialized = true;
	}
</script>

<svelte:component
	this={component.component}
	bind:this={instance}
	{...component.props}
	{...$$restProps}
/>
